<template>
  <div style="text-align: center; padding: 40px;">
    <p>正在处理...</p>
  </div>
</template>
<script>

export default {
  mounted() {
    // 微信回调到 /bindWechat?code=xxx&state=xxx，query参数在window.location.search中
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    // 发送消息给打开这个窗口的主页面
    if (window.opener && !window.opener.closed) {
      window.opener.postMessage(
        {
          type: 'WECHAT_BIND',
          data: {'code': code, 'state': state}
        },
        '*'
      );
      console.log('已发送消息给父窗口');
    }
  }
  // 5. 延迟关闭弹窗
  // setTimeout(() => {
  //   window.close();
  //   console.log('关闭当前页面')
  // }, 1500);
  // },
}
</script>
<style scoped lang="scss">

</style>
